import { render } from "./searchParts.vue?vue&type=template&id=63c93270"
import script from "./searchParts.vue?vue&type=script&lang=js"
export * from "./searchParts.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__